import { MonoTypeOperatorFunction, Observable } from 'rxjs';
import { startWith } from 'rxjs/operators';

export default function <T>(): MonoTypeOperatorFunction<T> {
  return ((input: Observable<T>) => input.pipe(startWith(<T>null))) as MonoTypeOperatorFunction<T>;
}
